<template>
	<el-card>
		<div slot="header">
			<span class="top_title">客户对账单</span>
		</div>
		<div class="searchItem">
			<div class="search">
				<span class="searchtips">日期:</span>
				<el-date-picker
					v-model="search.daterange"
					type="datetimerange"
					:picker-options="pickerOptions"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm"
					@change="searchOrder"
					align="right">
				</el-date-picker>
			</div>
			<Customer :orderForm="search" :hideStar='true'></Customer>
			<div class="search">
				<el-button type="primary" @click="searchOrder" icon="el-icon-search">查询</el-button>
			</div>
			<div class="search">
				<el-button
					type="primary"
					icon="el-icon-printer"
					@click="print"
					v-if="$common.checkWindowsEnv()"
					>打印</el-button>
				<el-button
					type='primary'
					icon="el-icon-document"
					@click="changePdf"
				>导出</el-button>
			</div>
		</div>
		<el-collapse v-model="activeNames" v-loading="loading">
			<el-collapse-item name="1">
				<template slot="title">
					<span class="col_title">总金额</span>
				</template>
				<span style="padding-right:20px">总销售额(元):{{sumTotal}}</span>
				<span style="padding-right:20px">总付款(元):{{sumPay}}</span>
				<span style="padding-right:20px">总免除(元):{{sumFree}}</span>
				<span style="padding-right:20px">总应收(元):{{sumNeedPay}}</span>
				<span>总期初(元):{{sumBeginbill}}</span>
			</el-collapse-item>
			<el-collapse-item name="2">
				<template slot="title">
					<span class="col_title">财务明细</span>
				</template>
				<el-table ref="multipleTable" :data="tableData" tooltip-effect="dark"  show-summary style="width: 100%;margin-bottom: 20px;" border>
					<el-table-column width='150px' label="日期" prop="date">
					</el-table-column>
					<el-table-column min-width='150px' label="客户" prop="name">
					</el-table-column>
					<el-table-column min-width='100px' label="收款(元)" prop="pay">
					</el-table-column>
					<el-table-column min-width='100px' label="免除(元)" prop="free">
					</el-table-column>
					<el-table-column min-width='100px' label="来源" prop="pfrom">
					</el-table-column>
					<el-table-column min-width='120px' label="结算账号" prop="accountname">
					</el-table-column>
					<el-table-column min-width='100px' label="经办人" prop="creator">
					</el-table-column>
					<el-table-column min-width='200px' label="备注" prop="remark">
					</el-table-column>
				</el-table>
			</el-collapse-item>
			<el-collapse-item name="3">
				<template slot="title">
					<span class="col_title">发货明细</span>
					<span style="padding-left:10px">货运:{{transport}} 电话:{{phone}}</span>
				</template>
				<el-table ref="multipleTable" :data="sendData" tooltip-effect="dark" show-summary :summary-method="getSummaries" style="width: 100%;margin-bottom: 20px;" border>
					<el-table-column min-width='150px' label="发货时间" prop="sdate">
					</el-table-column>
					<el-table-column width='150px' label="订单号" prop="onumber">
					</el-table-column>
					<el-table-column min-width='200px' label="商品" prop="pname">
					</el-table-column>
					<el-table-column min-width='110px' label="单位" prop="punit">
					</el-table-column>
					<el-table-column min-width='110px' label="发货数" prop="unit">
					</el-table-column>
					<el-table-column min-width='110px' label="退货数" prop="cancelUnit">
					</el-table-column>
					<el-table-column min-width='110px' label="发货人" prop="creator">
					</el-table-column>
					<el-table-column min-width='110px' label="单价(元)" prop="price">
					</el-table-column>
					<el-table-column min-width='110px' label="发货总价(元)" prop="sumPrice">
					</el-table-column>
					<el-table-column min-width='200px' label="备注" prop="remark">
					</el-table-column>
					<el-table-column min-width='200px' label="订单备注" prop="oremark">
					</el-table-column>
				</el-table>
				<el-pagination
					style="text-align: right"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-sizes="[20, 50, 120, 250]"
					:page-size="cp_pagesize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
					:pager-count="5"
				>
				</el-pagination>
			</el-collapse-item>
		</el-collapse>
		<ReportOrder ref="roder"></ReportOrder>
        <edit-share ref="share"></edit-share>
	</el-card>
</template>

<script>
import ReportOrder from '@/components/printshare/reportorder.vue';
import editShare from '@/components/printshare/edit_share';
import Customer from '@/components/customer'
export default {
	components: {Customer,ReportOrder,editShare},
	data() {
		return {
			loading: false,
			pickerOptions: {shortcuts:this.$common.initPickerOptions()},
			search: {
				cid: '',
				cname:' ',
				daterange: [],
			},
			activeNames:['1','2','3'],
			currentPage: 1,
			cp_pagesize: 20,
			total:0,

			sumBeginbill: 0,
			sumFree: 0,
			sumNeedPay: 0,
			sumPay: 0,
			sumTotal: 0,

			sumDesc:'',
			sumCancelUnit:0,
			sumPrice:0,

			tableData:[],
			pfree:0,
			ppay:0,

			sendData:[],
			transport:'',
			phone:'',
			searchObj:{

			}
		}
	},
	created(){
		var cid = this.$route.query.cid;
		var cname = this.$route.query.cname;
		if(cid>0){
			this.search.cid = cid;
			this.search.cname = cname;
			this.searchOrder();
		}else if(this.$global.userType==1){
			this.search.cid = this.$global.id;
			this.searchOrder();
		}
	},
	methods: {
		print(){
			if(this.searchObj.cid>0){
				let array = [this.searchObj.cid];
				this.$nextTick(()=>{
					this.$refs.roder.extraOpen(6,array);
				})
			}
		},
		changePdf(){
			if(this.searchObj.cid>0){
				let array = [this.searchObj.cid];
				this.$nextTick(()=>{
					this.$refs.share.openList(array,6,this.searchObj);
				})
			}
		},
		handleSizeChange(val) {
			this.cp_pagesize = val;
			this.searchOrder();
		},
		handleCurrentChange(val) {
			this.currentPage = val;
			this.searchObj.page = val;
			this.getData();
		},
		getSummaries(){
			let sums = [
				'合计',,,,
				this.sumDesc,
				,,,this.sumPrice,
			];
			
			return sums;
		},
		searchOrder(){
			this.searchObj = {
				page:this.currentPage,
				limit:this.cp_pagesize,
			}
			if(this.search.daterange&&this.search.daterange.length>=2){
				this.searchObj.start=this.search.daterange[0];
				this.searchObj.end=this.search.daterange[1];
			}
			if(this.search.cid){
				this.searchObj.cid = this.search.cid;
			}
			this.getData();
		},
		getData() {
			if(this.searchObj.cid == '') {
				this.$common.warning('请选择客户');
				return
			}
			this.loading = true;
			this.$api.getCustomerPayment(this.searchObj).then(res => {
				this.tableData = [];
				this.sendData = [];
				if(res.data.code==1){
					let dd = res.data.data;
					this.sumBeginbill = dd.sumBeginbill?dd.sumBeginbill:0;
					this.sumFree = dd.sumFree?dd.sumFree:0;
					this.sumNeedPay = dd.sumNeedPay?dd.sumNeedPay:0;
					this.sumPay = dd.sumPay?dd.sumPay:0;
					this.sumTotal = dd.sumTotal?dd.sumTotal:0;
					if(dd.paydata){
						dd.paydata.data.forEach(e=>{
							let obj = {
								uuid:e.uuid,
								date:e.date,
								name:e.cnumber+"-"+e.cname,
								pay:e.pay,
								free:e.free,
								pfrom:e.pfrom,
								accountname:e.accountname,
								creator:e.cteator,
								remark:e.remark?e.remark:'-',
							}
							if(e.pform=='订单收款'){
								obj.pfrom+=e.onumber;
							}
							this.tableData.push(obj);
						});
					}
					if(dd.sendData){
						this.total = dd.sendData.count;
						if(dd.sendData.customer){
							this.transport = dd.sendData.customer.transport;
							this.phone = dd.sendData.customer.phone;
						}
						this.sumDesc=this.$common.changeNumDesc(dd.sendData,'sumAmount','sumParts','sumUnit');
						this.sumCancelUnit=dd.sendData.sumCancelUnit;
						this.sumPrice=dd.sendData.sumPrice;
						dd.sendData.data.forEach(e=>{
							var spec = '';
							if(e.color){
								spec = '-'+e.color+'-'+e.size;
							}
							let obj = {
								sdate:e.sdate,
								onumber:e.onumber,
								pname:e.pnumber+'-'+e.pname+spec,
								punit:e.punit+this.$global.unit+'/'+this.$global.pack,
								unit:this.$common.changeNumDesc(e),
								cancelUnit:this.$common.changeSendDesc(e.cancelUnit,e.punit),
								creator:e.creator,
								price:e.price,
								sumPrice:e.sumPrice,
								remark:e.remark?e.remark:'-',
								oremark:e.oremark?e.oremark:'-',
							}
							this.sendData.push(obj);
						})
					}
				}
				this.loading = false;
			}, () => {
				this.loading = false;
			})
		},
	}
}
</script>